var _clipPath;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCreateCicdPackage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd"
  },
  viewBox: "0 0 33 28"
}, props), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.4074 0 0 .45902 -34.63 -1.836)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M85 4h81v61H85z",
  style: {
    fill: "none"
  }
}), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "create_cicd_package_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M85 4h81v61H85z"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#create_cicd_package_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(2.45455 0 0 2.17857 -209.545 -48.286)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m136.35 51 1.65-1.668-3.99-4.033-1.65 1.668L136.35 51Zm-11.115-14.678h4.095v6.612L123 49.332 124.65 51l7.02-7.096v-7.582h4.095L130.5 31l-5.265 5.322Z",
  style: {
    fill: "currentColor",
    fillRule: "nonzero"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 34,
  r: 8,
  style: {
    fill: "currentColor",
    stroke: "transparent",
    strokeWidth: 2
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M137 33h8v2h-8z",
  style: {
    fill: "hsl(211deg 77% 70%)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M140 30h2v8h-2z",
  style: {
    fill: "hsl(211deg 77% 70%)"
  }
})))));
export default SvgCreateCicdPackage;